module.exports = __WEBPACK_EXTERNAL_MODULE_42__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"react-dom","commonjs":"react-dom"}
 ** module id = 42
 ** module chunks = 0
 **/